import type { Produto } from "@/components/vitrine/types/produto.props"
import { slugify } from "@/utils/slugify"

export function getLinkProduto(produto: Produto): string {
    if (!produto?.link) return ''

    let finalLink = `/${produto.link}`
    const tipoRegistro = produto.tipo_registro ?? false
    const paginaPrincipal = produto.pag_principal ?? false
    const derivacaoNome = produto.derivacao_nome ?? false

    if (
        tipoRegistro &&
        [2, 3].includes(tipoRegistro) &&
        !paginaPrincipal &&
        derivacaoNome
    ) {
        finalLink += `#derivacao=${slugify(derivacaoNome)}`
    }

    return finalLink
}
